
(ns app.strive-forms.question-fields.email-input-field
  (:require [app.http :as http]
            [app.strive-forms.component-multi-methods :refer [calc-error-message
                                                              show-action-btn? update-question-input-data update-question-input-local]]
            [app.strive-forms.defaults :refer [default-values]]
            [app.strive-forms.events :as sfevents]
            [app.strive-forms.helper-functions :refer [check-button-status
                                                       color-condition
                                                       component-alignment get-default-text-val get-error-message-color get-required-message
                                                       on-focus-toggle required-and-empty? save-value-on-last-page set-values-for-button!
                                                       update-preview-panel!]]
            [app.strive-forms.styles :refer [email-icon-style
                                             responsive-input-field-border-class
                                             responsive-input-field-style warning-notification]]
            [clojure.string :as s]
            [re-com.core :as re-com :refer [h-box v-box]]
            [re-frame.core :as re-frame]
            [reagent-mui.icons.email-outlined :refer [email-outlined]]
            [reagent-mui.material.box :refer [box]]
            [reagent-mui.material.text-field :refer [text-field]]
            [reagent.core :as r])
  (:import [goog.async Delay]))

(defn validate-email [email]
  (let [pattern #"(?i)[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])"]
    (and (string? email)
         (some? (re-matches pattern email)))))

(defn set-email-validation-score! [text-val score] ;;TODO: API outside
  (-> (http/post "https://api.sendgrid.com/v3/validations/email" {:body {"email" text-val
                                                                         "source" "signup"}})
      (-> (.then #(reset! score (:score (:result %)))))))


(defn on-change-action [{:keys [text-val value email-button-disabled? email-valid? reset-delay new-session score final-page?
                                input-data field-id regenerate-display-fields]}]
  (reset! text-val value)
  (when @new-session (reset! new-session false))

  (if (validate-email value)
    (do
      (reset! email-valid? true)
      (reset! email-button-disabled? false)
      (save-value-on-last-page {:final-page? final-page? :input-data input-data :field-id field-id
                                :regenerate-display-fields regenerate-display-fields :text-val text-val}))

    (reset-delay
     (reset! email-button-disabled? true)))

  (when (validate-email value) (set-email-validation-score! value score)))


(defn show-email-invalid! [{:keys [new-session email-button-disabled? email-valid? score]}]
  (fn []
    (when (and (not @new-session) @email-button-disabled?)
      (reset! email-valid? false))
    (when (< @score 1)
      (reset! email-valid? false))))

(defn invalidate-from-score [{:keys [email-valid? email-button-disabled?]}]
  (reset! email-button-disabled? true)
  (reset! email-valid? false))

(defmethod update-question-input-local "email" [{:keys [input-data field-id input-value]}]
  (re-frame/dispatch [::sfevents/update-input-local
                      {:input-data input-data :key (keyword field-id) :value input-value}]))

(defmethod update-question-input-data "email" [{:keys [input-data field-id input-value]}]
  (update input-data (keyword field-id) (fn [value]
                                          (assoc value :value input-value))))

(defn- get-email-invalid-error-msg [{:keys [form-messages]}]
  (:email_invalid form-messages (:invalid (:email (:errors default-values)))))

(defn- get-email-unverified-error-msg [{:keys [form-messages]}]
  (:email_unverified form-messages (:verification (:email (:errors default-values)))))


(defmethod calc-error-message "email" [{:keys [input-value field form-messages valid? new-session score]}]
  (let [text-val (:input-value (first @input-value))
        score @score
        required-message (get-required-message {:form-messages form-messages})
        invalid-email-message (get-email-invalid-error-msg {:form-messages form-messages})
        email-verification-error-message (get-email-unverified-error-msg {:form-messages form-messages})]
    (cond (and (not @valid?) (:is_required field) (s/blank? text-val)) required-message
          (zero? score) email-verification-error-message
          @valid? ""
          (not (s/blank? text-val)) invalid-email-message
          :else "")))

(defmethod show-action-btn? "email" [_]
  true)

(defn make-delayer [f interval]
  (let [delayer (Delay. f interval)]
    (fn [] (.start delayer))))

(defn email-input-label [{:keys [email-valid? on-focus theme-data text-val reset-delay email-button-disabled?
                                 new-session form-messages score final-page? input-data field-id regenerate-display-fields]}]
  [h-box
   :class (responsive-input-field-border-class {:border-color (color-condition {:valid? @email-valid?
                                                                                :on-focus @on-focus
                                                                                :theme-data theme-data
                                                                                :default-color (:dark-gray (:themes default-values))})
                                                :border-size (str (if @on-focus "2px" "1px") " solid")
                                                :margin (when @on-focus "-1px")
                                                :width "95%"})
   :children [[box {:sx {:display "flex" :alignItems "flex-end"}}
               [email-outlined {:sx {:color "action.active" :mr 1 :my 0.5}
                                :class (email-icon-style)}]
               [text-field {:variant "filled"
                            :style {:background "transparent"}
                            :max-rows 1
                            :defaultValue @text-val
                            :model          @text-val
                            :InputProps  {:disableUnderline true}
                            :InputLabelProps {:shrink (if (s/blank? @text-val) nil "true")}
                            :label  (:email_input_label form-messages (:email_input_label default-values))
                            :on-focus (on-focus-toggle on-focus)
                            :on-change (fn [x]
                                         (on-change-action {:text-val text-val :value (-> x .-target .-value) :email-button-disabled? email-button-disabled?
                                                            :email-valid? email-valid? :reset-delay reset-delay :new-session new-session :score score
                                                            :final-page? final-page? :input-data input-data :field-id field-id
                                                            :regenerate-display-fields regenerate-display-fields}))
                            :on-blur (on-focus-toggle on-focus)}]]]])





(defn email-input-field [{:keys [field-id input-data default-value current-page index]}]
  (let [text-val (r/atom (get-default-text-val {:input-data input-data :field-id field-id :default-value default-value
                                                :current-page @current-page :index index}))
        email-valid? (r/atom true)
        score (r/atom 1)
        email-button-disabled? (r/atom true)
        on-focus (r/atom false)
        new-session (r/atom true)
        reset-delay (make-delayer (show-email-invalid! {:new-session new-session :email-button-disabled? email-button-disabled? :email-valid? email-valid?}) 1000)]
    (when (and @email-valid? (not (s/blank? @text-val))) (reset! email-button-disabled? false))
    (fn [{:keys [field theme-data form-messages input-value button-ids-for-button is-multi-question? input-data]}]
      (update-preview-panel! {:input-data input-data :field-id field-id
                              :value-to-update @text-val
                              :condition (not (s/blank? @text-val))})
      (when (zero? @score) (invalidate-from-score {:email-button-disabled? email-button-disabled? :email-valid? email-valid? :score score}))
      (add-watch text-val :watcher
                 (fn []
                   (set-values-for-button! {:input-value input-value :component-input-value text-val
                                            :field-id field-id :type (:type field)})))
      (check-button-status {:component-button-disabled? email-button-disabled? :field-id field-id
                            :button-ids-for-button button-ids-for-button})
      (required-and-empty? {:text-val text-val :field field :valid? email-valid?})
      [v-box
       :width "100%"
       :align (component-alignment is-multi-question?)
       :justify :center
       :children [[:div
                   {:class
                    (responsive-input-field-style {:input-font-color (color-condition {:valid? @email-valid?
                                                                                       :on-focus false
                                                                                       :theme-data nil
                                                                                       :default-color (:light-gray (:themes default-values))})
                                                   :title-field-color (color-condition {:valid? (not @email-button-disabled?)
                                                                                        :on-focus @on-focus
                                                                                        :theme-data theme-data
                                                                                        :default-color (:dark-gray (:themes default-values))
                                                                                        :is-label? true})
                                                   :border-color (color-condition {:valid? @email-valid?
                                                                                   :on-focus @on-focus
                                                                                   :theme-data theme-data
                                                                                   :default-color (:dark-gray (:themes default-values))})})}
                   [email-input-label {:email-valid? email-valid? :on-focus on-focus :theme-data theme-data :text-val text-val :reset-delay reset-delay
                                       :email-button-disabled? email-button-disabled? :new-session new-session :form-messages
                                       form-messages :score score}]
                   [:div {:class (warning-notification {:width "350px"
                                                        :color (get-error-message-color new-session)})}
                    (calc-error-message {:input-value input-value :valid? email-valid? :type "email"
                                         :field field :form-messages form-messages
                                         :new-session new-session :score score})]]]])))
